import { Budget, RBudget } from '@dh/types';

export const mapBudget = (budget: RBudget): Budget => ({
    min: budget.min,
    // we use the 'NaN' string to represent a missing max value, because Number.NaN cannot be properly serialized by NextJS
    max: budget?.max ?? 'NaN',
    currency: budget.currency ?? 'EUR'
});
